import React from 'react';

const Users = () => {
    return (
        <div>
            <h1>user</h1>
            <h1>user</h1>
        </div>
    );
};

export default Users;